export default "<p>auth works!</p>\r\n";